import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {DepositRewardConfig, DepositRewardConfigListResponse} from "../http/protocol";

export class DepositRewardConfigService extends AbstractAdminEntityService<DepositRewardConfig, DepositRewardConfigListResponse> {

    constructor(http: HttpService) {
        super("/deposit-reward-config", http)
    }
}
